import React, { useState, useEffect, useRef } from "react";
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react'
import { CheckBadgeIcon } from '@heroicons/react/24/outline'

const DownloadStatement = ({ options }) => {
  const { openDownloadModal, setOpenDownloadModal, handleDownloadExcel, handleExportPDF, handleExportExcel } = options;
  const [format, setFormat] = useState("");

  const download = (format) => {
    if(format === 'excel'){
      handleDownloadExcel()
      handleExportExcel()
      setOpenDownloadModal(!openDownloadModal)
    }else{
      handleExportPDF()
      setOpenDownloadModal(!openDownloadModal)
    }
  }

  return (
    <Dialog open={openDownloadModal} onClose={setOpenDownloadModal} className="relative z-20">
    <DialogBackdrop
      transition
      className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
    />
    <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
      <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
        <DialogPanel
          transition
          className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
        >
          <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
            <div className="sm:flex sm:items-start">
              <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                <CheckBadgeIcon aria-hidden="true" className="h-6 w-6 text-red-600" />
              </div>
              <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left w-full" >
                <DialogTitle as="h2" className="text-base font-semibold leading-6 text-gray-900">
                    Download Statement
                </DialogTitle>

                  {/* File Format Dropdown */}
                  <div className="mb-6">
                    <label className="block text-sm font-medium text-brand-3 mb-1">
                      File Format
                    </label>
                    <select id="downloadStatement" onChange={e => setFormat(e.target.value)} value={format} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                        <option selected>Select Format</option>
                      
                          <option value='excel'>Excel</option> 
                          <option value='pdf'>PDF</option> 
                    
                      </select>
                  </div>
              </div>
            </div>
          </div>
          <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
            <button
              type="button"
              onClick={download}

              className="inline-flex w-full justify-center rounded-md bg-green-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-500 sm:ml-3 sm:w-auto"
            >
              Download
            </button>
            <button
              type="button"
              data-autofocus
              onClick={() => setOpenDownloadModal(false)}
              className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
            >
              Cancel
            </button>
          </div>
        </DialogPanel>
      </div>
    </div>
    </Dialog>
  );
};

export default DownloadStatement;
